"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cart_vue_1 = __importDefault(require("@/Views/Components/Project/Layouts/AppLayout/TopBar/Cart.vue"));
var ProfileDropdown_vue_1 = __importDefault(require("@/Views/Components/Project/Layouts/AppLayout/TopBar/ProfileDropdown.vue"));
var route_1 = __importDefault(require("@/Modules/Misc/route"));
var routes_1 = require("@/routes");
var components = {
    CartLink: Cart_vue_1.default,
    ProfileDropdown: ProfileDropdown_vue_1.default
};
exports.default = {
    components: components,
    props: {
        breadcrumbs: {
            required: true,
            type: Array
        },
        hideBreadcrumbs: {
            type: Boolean,
            default: true,
        },
        logoFullPath: {
            type: String,
            required: false
        },
        user: {
            type: Object,
            required: false
        },
        showAdminLinks: {
            required: false,
            type: Boolean,
        },
        profileAdminLinks: {
            required: false,
            type: Array
        },
        flash: {
            type: Object,
            required: true
        },
        currentRoute: {
            type: Object,
            required: true
        },
        unpaidWinsCount: {
            type: Number,
            required: false
        },
        mainRoleDisplayName: {
            type: String,
            required: false
        },
        cartPageNumber: {
            type: Number,
            default: 1
        },
        mainBoard: {
            type: Object,
            required: true
        },
        boardViaUrl: {
            type: Object,
            required: false
        },
        footerLogo: {
            type: String,
            required: true
        },
        bankIsActive: {
            type: Boolean,
            default: false
        },
        showBottomNavigation: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isCartRoute: function () {
            return window.location.href == this.cartRoute.toString();
        },
        cartRoute: function () {
            return (0, route_1.default)(routes_1.CART_PAGE);
        }
    }
};
